import { normalizeLinkHref } from './normalizeLinkHref';

/**
 * '' = no link (monday 13065458913): edit never links, preview links only a real URL,
 * production keeps the tag. Pair with stripEmptyListingHrefs. A user-typed address
 * is made absolute (monday 13291045384); tags and '' pass through unchanged.
 */
export function resolveListingHref(
	rawHref: string | undefined | null,
	actualMode: 'edit' | 'preview' | 'production',
	fallback: string,
): string {
	// Normalize first: a whitespace-only address is "no address", so the fallback applies.
	const href = normalizeLinkHref(rawHref) || fallback;
	if (actualMode === 'production') return href;
	return actualMode === 'edit' || href.includes('{{') ? '' : href;
}

/** Remove the href="" resolveListingHref leaves behind, so the anchor stops being a link. */
export function stripEmptyListingHrefs(html: string): string {
	return html.replace(/(<a\b[^>]*?)\s+href=""/gi, '$1');
}

/**
 * Multiple / By Criteria cards render inside {{#each listings}}, where the listing's
 * fields are bare - so the canonical {{listing.url}} field becomes {{url}} (monday 13122054004).
 */
export function toLoopListingHref(href: string | undefined | null): string | undefined | null {
	return typeof href === 'string' ? href.replace(/\{\{\s*listing\.url\s*\}\}/g, '{{url}}') : href;
}

const SAMPLE_LISTING_URL = 'https://example.com/listing';

/** True when a listing block's link is the listing's own URL field. */
export function isListingUrlTag(href: string | undefined | null): boolean {
	return /^\s*\{\{\s*(listing\.)?url\s*\}\}\s*$/i.test(href || '');
}

/**
 * Preview link for a listing's own URL field (monday 13122054004): the absolute link, or
 * the relative `url` path on the agent's office domain - how the send builds it
 * (campaignevents.cfc) - or '' (no link) for a sample card with no real listing.
 */
export function previewListingUrl(url: string | undefined | null, officeDomain?: string | null): string {
	// A host-less "https:///path" (composed with an empty office domain) is a path too.
	const value = (url || '').trim().replace(/^https?:\/\/(?=\/)/i, '');
	if (!value || value === SAMPLE_LISTING_URL) return '';
	if (/^https?:\/\/[^/]/i.test(value)) return value;
	const domain = (officeDomain || '').trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '');
	return value.startsWith('/') && domain ? `https://${domain}${value}` : '';
}
